module.exports = __webpack_public_path__ + "static/img/home_cpjfw_hwaqfw.322c7e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_cpjfw_hwaqfw.png
// module id = wnl/
// module chunks = 21